import { defineComponent, PropType } from 'vue';

import { reactiveVueMixin } from '@skinsoft/reactive-vue';


import { getLabelCoordinates } from '@skinsoft/entity-ui/src/condition-report/drawing-toolbox/label-coordinates-helper';
import { ShapeConfig } from '@skinsoft/entity-ui/src/condition-report/drawing-toolbox';

interface AnnotationLabelConfig {
    fontSize: number
    radius: number
    strokeWidth: number
}

export const AnnotationDrawing = defineComponent({
    mixins: [reactiveVueMixin],
    props: {
        shapeConfig: { type: Object as PropType<ShapeConfig>, required: true },
        index: { type: [Number, String] as PropType<number | string> },
        labelConfig: { type: Object as PropType<AnnotationLabelConfig>, required: true },
        zIndex: { type: Number },
    },
    template: require('./annotation-drawing.html'),
    data() {
        return {
            labelNode: null as any,

            textConfig: {
                align: 'left',
                fill: 'black',
                fontFamily: 'Calibri',
                fontSize: 18,
                offsetX: 0,
                offsetY: 0,
                text: '1',
                x: 0,
                y: 0,
            },

            textBgConfig: {
                fill: "white",
                radius: 15,
                stroke: "black",
                strokeWidth: 2,
                x: 0,
                y: 0,
            },
        }
    },
    mounted() {
        // The label only renders when `index` is truthy: shapes past a stroke's first point get
        // an empty-string index, so the ref is absent here; centerTextInLabel() tolerates null.
        this.labelNode = (this.$refs.label as any)?.getNode() ?? null;
    },
    methods: {
        centerTextInLabel() {
            if(this.labelNode) {
                this.textConfig.offsetX = this.labelNode.width() / 2
                this.textConfig.offsetY = this.labelNode.height() / 2
            }
        },
    },
    watch: {
        shapeConfig: {
            handler() {
                // updating shape label
                const labelCenter = getLabelCoordinates(this.shapeConfig, this.textBgConfig.radius)

                this.textBgConfig.x = labelCenter.x
                this.textBgConfig.y = labelCenter.y

                this.textConfig.text = String(this.index);
                this.textConfig.x = labelCenter.x
                this.textConfig.y = labelCenter.y

                this.$nextTick(this.centerTextInLabel)
            },
            immediate: true,
            deep: true,
        },
        labelConfig: {
            handler() {
                this.textBgConfig.radius = this.labelConfig.radius
                this.textBgConfig.strokeWidth = this.labelConfig.strokeWidth
                this.textConfig.fontSize = this.labelConfig.fontSize;

                this.$nextTick(this.centerTextInLabel)
            },
            immediate: true,
            deep: true,
        },
    },
})
